// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"e_Wx","title":"e_Xx","container":"e_Yx","list":"e_Zx"};